<script>
    import FormModal from '../../components/modals/FormModal.vue';
    import FormDropdown from '../../components/forms/FormDropdown.vue';
    import SpinnerLoader from '../../components/loaders/SpinnerLoader.vue';
    import FormSwitchCheckbox from '../../components/forms/FormSwitchCheckbox.vue';
    import Button from '../../components/buttons/Button';
    import Pagination from '../../components/paginations/Pagination';
    import CheckboxAndActionsTable from '../../components/tables/CheckboxAndActionsTable';

    export default {
        components: {
            FormModal,
            FormDropdown,
            SpinnerLoader,
            FormSwitchCheckbox,
            Button,
            Pagination,
            CheckboxAndActionsTable
        },

        props: {
            all_user: {
                type: Array,
                default: function () {
                    return [];
                },
            },
            paginationDetails: {
                type: Object,
                default: function () {
                    return {};
                },
            },
            allStripePlans: {
                type: Object,
                default: function () {
                    return {};
                },
            },
            clientListType: {
                type: String,
                default: function () {
                    return null;
                },
            },
            showOnboardingChecklistModalFunc: {
                type: Function,
                required: true
            }
        },

        data() {
            return {
                loginForm: {
					user_id: null,
                    platform: 'Vue'
				},
                showStatusManagementModal: false,
                statusManagementData: {
                    id: null,
                    status: null,
                    statusFlag: false,
                    loginAttempts: null,
                    paymentStatus: null,
                    paymentColor: null,
                    paymentTitle: null,
                    paymentDetails: null,
                    paymentDetailStatus: null,
                    phaseStatus: null,
                    phaseColor: null,
                    phaseTitle: null,
                    full_name: null,
                    email: null,
                    user_type: 0,
                    extendTrial: false,
                    routesOrUrl: null
                },
                isStatusActiveInactiveLoading: false,
                isPhaseStatusLoading: false,
                isShowPlans: false,
                isShowCustomPay: false,
                customPayForm: {
					planId: 0,
					amount: 0,
				},
                isCustomPayLoading: false,
                isExtendTrialLoading: false,
                phaseStatusData: [
                    {  id: 1, value: 'Active' },
                    {  id: 2, value: 'Negotiation' },
                    {  id: 3, value: 'Demo' },
                    {  id: 4, value: 'Prospecting' }
                ],
            }
        },

        methods: {
            handleLoginFormSubmit(url, id) {
                this.loginForm.user_id = id;
				this.$inertia.post(
					url,
					this.loginForm,
					{
						onError: (errors) => {
                            if(errors.message) {
							    this.$toastr.e(errors.message);
                            }
						}
					}
				)
			},

            statusManagement(id, status, loginAttempts, paymentStatus, paymentColor, paymentTitle, paymentDetails, paymentDetailStatus, phaseStatus, phaseColor, phaseTitle, full_name, email, user_type, routesOrUrl) {
                this.statusManagementData.id = id
                this.statusManagementData.status = status
                this.statusManagementData.loginAttempts = loginAttempts
                this.statusManagementData.paymentStatus = paymentStatus
                this.statusManagementData.paymentColor = paymentColor
                this.statusManagementData.paymentTitle = paymentTitle
                this.statusManagementData.paymentDetails = paymentDetails
                this.statusManagementData.paymentDetailStatus= paymentDetailStatus                
                this.statusManagementData.phaseStatus = phaseStatus
                this.statusManagementData.phaseColor = phaseColor
                this.statusManagementData.phaseTitle = phaseTitle
                this.statusManagementData.full_name = full_name
                this.statusManagementData.email = email
                this.statusManagementData.user_type = user_type
                this.statusManagementData.routesOrUrl = routesOrUrl
                this.statusManagementData.statusFlag = false
                if(this.statusManagementData.status == 1 && this.statusManagementData.loginAttempts < 3) {
                    this.statusManagementData.statusFlag = true
                }
                this.showStatusManagementModal = true;
                this.isShowPlans = false;
                this.isShowCustomPay = false;
            },

            handleStatusActiveInactive(event) {
                this.isStatusActiveInactiveLoading = true;
                let status = 0;
                let statusMsg = 'Inactive Successfully!';
                if(event) {
                    status = 1;
                    statusMsg = 'Active Successfully!';
                }
                this.$inertia.post(
					this.statusManagementData.routesOrUrl.accountStatus,
					{
                        "mydata" : {
                            id: this.statusManagementData.id,
                            status: status,
                            platform: 'Vue'
                        }
                    },
					{
						onSuccess: (response) => {
							this.$toastr.s(statusMsg);
                            this.isStatusActiveInactiveLoading = false;
                            this.showStatusManagementModal = false;
						},
						onError: (errors) => {
                            this.isStatusActiveInactiveLoading = false;
                            if(errors.message) {
							    this.$toastr.e(errors.message);
                            }
						}
					}
				)
            },

            handlePhaseStatus(status) {
                this.isPhaseStatusLoading = true;
                this.$inertia.post(
					this.statusManagementData.routesOrUrl.leadTypes,
					{
                        user_id: this.statusManagementData.id,
                        phase_status: status,
                        platform: 'Vue'
                    },
					{
						onSuccess: (response) => {
							this.$toastr.s('Phase Status Updated Successfully!');
                            this.isPhaseStatusLoading = false;
                            this.showStatusManagementModal = false;
						},
						onError: (errors) => {
                            this.isPhaseStatusLoading = false;
                            if(errors.message) {
							    this.$toastr.e(errors.message);
                            }
						}
					}
				)
            },

            showPlans() {
                this.isShowPlans = true;
            },

            showCustomPay(amount, planId) {
                this.$page.props.errors.price = false;
                this.$page.props.errors.planError = false;
                this.isShowCustomPay = true;
                this.customPayForm.amount = amount;
                this.customPayForm.planId = planId;
            },

            setTwoNumberDecimal(event) {
                this.customPayForm.amount = parseFloat(event.target.value).toFixed(2);;
            },

            handleCustomPayment() {
                this.$page.props.errors.price = false;
                this.$page.props.errors.planError = false;
                this.isCustomPayLoading = true;
                this.$inertia.post(
					this.statusManagementData.routesOrUrl.customPay,
					{
                        user_id: this.statusManagementData.id,
                        price: this.customPayForm.amount,
                        plan_id: this.customPayForm.planId
                    },
					{
						onSuccess: (response) => {
							this.$toastr.s('Paid Successfully!');
                            this.isCustomPayLoading = false;
                            this.showStatusManagementModal = false;
						},
						onError: (errors) => {
                            this.isCustomPayLoading = false;
                            if(errors.message) {
							    this.$toastr.e(errors.message);
                            }
						}
					}
				)
            },

            handleExtendTrial(event) {
                this.isExtendTrialLoading = true;
                this.$inertia.post(
					this.statusManagementData.routesOrUrl.extendTrial,
					{
                        id: this.statusManagementData.id
                    },
					{
						onSuccess: (response) => {
							this.$toastr.s('Trial Extended!');
                            this.isExtendTrialLoading = false;
                            this.showStatusManagementModal = false;
						},
						onError: (errors) => {
                            this.isExtendTrialLoading = false;
                            if(errors.message) {
							    this.$toastr.e(errors.message);
                            }
						}
					}
				)
            },

            hideModal() {
                this.showStatusManagementModal = false;
            }
        },
        computed: {
            // Example 1,2,3,4
            userType() {
                return this.$page.props.auth.user.user_type;
            },
            isUltraAdmin() {
                return this.$page.props.auth.user.is_ultra_admin
            }
        }
    }
</script>

<template>
    <div class="row">
        <div class="col-lg-12">
            <CheckboxAndActionsTable
                :datas="all_user"
                :onClick="statusManagement"
                :onClickToLogin="handleLoginFormSubmit"
                :clientListType="clientListType"
                :showOnboardingChecklistModalFunc="showOnboardingChecklistModalFunc"
            />
        </div>
        <div class="col-lg-12">
            <Pagination v-if="all_user.length > 0" :paginationDetails="paginationDetails" />
        </div>
        <FormModal
            :isShow="showStatusManagementModal"
            :title="statusManagementData.full_name + ', ' + statusManagementData.email"
            :isButtonLoading="false"
            :isShowSubmitButton="false"
            :isShowCancelButton="false"
            @hideModal="hideModal"
        >
            <div class='row'>
                <div class='col-sm-4 mb-3'>
                    <label>Account Status</label>
                </div>
                <div class='col-sm-8 mb-3'>
                    <FormSwitchCheckbox v-if="!isStatusActiveInactiveLoading" id="activate_status" v-model="statusManagementData.statusFlag" name="activate_status" label="" @input="handleStatusActiveInactive($event)" classes="mb-3" />
                    <SpinnerLoader v-else classes="spinner-border text-success" role="status" title="Loading..." />
                </div>
                <template v-if="this.statusManagementData.user_type != 4">
                    <div class='col-sm-4 mb-3'>
                        <label>Payment Status</label>
                    </div>
                    <div class='col-sm-8 mb-3'>
                        <template v-if="statusManagementData.paymentStatus == 1">
                            <span class='badge rounded-pill bg-success'>
                                {{ statusManagementData.paymentTitle }}
                            </span>
                            &nbsp;
                            <span class="badge rounded-pill badge-soft-info">
                                {{ statusManagementData.paymentDetails }}
                            </span>
                        </template>
                        <template v-else-if="statusManagementData.paymentStatus == 2">
                            <span class='badge rounded-pill badge-soft-danger'>
                                <b>Trial Over</b>
                            </span>
                            <template v-if="userType == 1 && !isUltraAdmin">
                                <Button 
                                    classes='btn btn-info btn-rounded waves-effect waves-light'
                                    :onClick="showPlans"
                                >
                                    Pay Now
                                </Button>
                                <span class='px-1'>OR</span>
                            </template>
                            <template v-if="!isUltraAdmin">                         
                                <FormSwitchCheckbox v-if="!isExtendTrialLoading" id="extend_trial" v-model="statusManagementData.extendTrial" name="extend_trial" label="Extend Trial" @input="handleExtendTrial($event)" classes="mb-3" />
                                <SpinnerLoader v-else classes="spinner-border text-success" role="status" title="Loading..." />
                            </template>            
                        </template>
                        <template v-else-if="statusManagementData.paymentStatus == 3">
                            <span class='badge rounded-pill badge-soft-info'>
                                <b>{{statusManagementData.paymentTitle}}</b>
                            </span>
                            &nbsp;
                            <Button 
                                v-if="userType == 1 && !isUltraAdmin"
                                classes='btn btn-info btn-rounded waves-effect waves-light'
                                :onClick="showPlans"
                                >
                                Pay Now
                            </Button>
                        </template>
                        <template v-else-if="statusManagementData.paymentStatus == 4">
                            <span class='badge rounded-pill badge-soft-info'>
                                <b>{{statusManagementData.paymentTitle}}</b>
                            </span>
                        </template>
                        <template v-else-if="statusManagementData.paymentStatus == 5">
                            <span class='badge rounded-pill badge-soft-danger'>
                                <b>No Payment Attempt Yet</b>
                            </span>
                            &nbsp;
                            <Button 
                                v-if="userType == 1 && !isUltraAdmin"
                                classes='btn btn-info btn-rounded waves-effect waves-light'
                                :onClick="showPlans"
                                >
                                Pay Now
                            </Button>
                        </template>
                        <template v-else>
                            <span class='badge rounded-pill badge-soft-danger'>
                                <b>Subscription Failed</b>
                            </span>
                            &nbsp;
                            <Button 
                                v-if="userType == 1 && !isUltraAdmin"
                                classes='btn btn-info btn-rounded waves-effect waves-light'
                                :onClick="showPlans"
                                >
                                Pay Now
                            </Button>
                        </template>
                        <div class="row mt-2 ml-2" v-if="isShowPlans" :class="{'is-invalid': $page.props.errors.planError}">
                            <div v-for="(plan, index) in allStripePlans.data" :key="index" class="col-sm-5 form-check form-radio-success mb-3">
                                <input class="form-check-input" type="radio" :id="plan.metadata.type" name="custom_pay_type" @click="showCustomPay((plan.amount)/100, plan.id)">
                                <label class="form-check-label" :for="plan.metadata.type">
                                    {{ plan.metadata.type }}, <i class='fas fa-dollar-sign'></i>{{ (plan.amount)/100 }}
                                </label>
                            </div>
                            <div
                                v-if="$page.props.errors.planError"
                                class="invalid-feedback"
                            >
                                {{$page.props.errors.planError}}
                            </div>
                        </div>
                        <div class="row mt-2 ml-2" v-if="isShowCustomPay">
                            <div class="input-group">
                                <div class="input-group-text"><i class='fas fa-dollar-sign'></i></div>
                                <input type='number' v-model="customPayForm.amount" class='form-control' min='1' step='0.25' @change="setTwoNumberDecimal($event)" :class="{'is-invalid': $page.props.errors.price}">
                                <div class='input-group-text'>
                                    <Button
                                        type='button'
                                        classes='btn btn-success'
                                        :onClick="handleCustomPayment"
                                        :disabled="isCustomPayLoading"
                                        v-if="!isCustomPayLoading"
                                    >
                                        Pay
                                    </Button>
                                    <Button
                                        type='button'
                                        classes='ms-1'
                                        :onClick="handleCustomPayment"
                                        :disabled="isCustomPayLoading"
                                        v-else
                                    >
                                        <i class="bx bx-loader bx-spin font-size-16 align-middle"></i>
                                    </Button>
                                </div>
                                <div
                                    v-if="$page.props.errors.price"
                                    class="invalid-feedback"
                                >
                                    {{$page.props.errors.price}}
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
                <div class='col-sm-4'>
                    <label>Lead Type</label>
                </div>
                <div class='col-sm-8'>
                    <FormDropdown
                        v-if="!isPhaseStatusLoading"
                        variant="primary"
                        :title="statusManagementData.phaseTitle"
                        :datas="phaseStatusData"
                        :handleSelect="handlePhaseStatus"
                        :selectedId="statusManagementData.phaseStatus"
                    />
                    <SpinnerLoader v-else classes="spinner-border text-success" role="status" title="Loading..." />
                </div>
            </div>
        </FormModal>
    </div>
</template>
